export default "__VITE_PUBLIC_ASSET__a1785df6__"